import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import jobReducer from "../Redux/Reducers/JobReducer";
import authMiddleware from "../Redux/middlewares/authMiddleware";
import ProfileReducer from "../Redux/Reducers/ProfileReducer";
import cardReducer from "../Redux/Reducers/CardReducer";
import ContactReducer from "../Redux/Reducers/ContactReducer";
import OnboardingReducer from "../Redux/Reducers/OnboardingReducer";
import KycReducer from "../Redux/Reducers/KycReducer";
import calenderReducer from "../Redux/Reducers/calendarReducer";
import communityReducer from "../Redux/Reducers/communityReducer";
import numerologyReducer from '../Redux/Reducers/numerologyReducer';
import cceReducer from '../Redux/Reducers/cceReducer';
import letterHeadReducer from "../Redux/Reducers/letterHeadReducer.ts"
import ProductReducer from "../Redux/Reducers/ProductsReducer"
import VerifiedDocReducer from "../Redux/Reducers/VerifiedDocReducer";
import EnterpriseReducer from "../Redux/Reducers/EnterpriseReducer";
import documentReducer from "../Redux/Reducers/documentReducer.ts"

const persistConfig = {
  key: "root",
  version: 1,
  storage: storage,
};

const rootReducer = combineReducers({
  jobs: jobReducer,
  ProfileArray: ProfileReducer,
  CardArray: cardReducer,
  ContactArray: ContactReducer,
  onboarding: OnboardingReducer,
  Kyc: KycReducer,
  calender: calenderReducer,
  community: communityReducer,
  numerology:numerologyReducer,
  letterHead: letterHeadReducer,
  cce:cceReducer,
  products:ProductReducer,
  verified:VerifiedDocReducer,
  enterprise:EnterpriseReducer,
  document: documentReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(authMiddleware),
});

export const persistor = persistStore(store);
